import { render, staticRenderFns } from "./AddItemComponent.vue?vue&type=template&id=7ab6ec80&"
import script from "./AddItemComponent.vue?vue&type=script&lang=js&"
export * from "./AddItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports